import { render } from "./NewAppointmentCard.vue?vue&type=template&id=9e3506e6&scoped=true"
import script from "./NewAppointmentCard.vue?vue&type=script&lang=js"
export * from "./NewAppointmentCard.vue?vue&type=script&lang=js"

import "./NewAppointmentCard.vue?vue&type=style&index=0&id=9e3506e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e3506e6"]])

export default __exports__